import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from "react";
import { listMetaObjects } from "../api";

/**
 * The org's meta objects, fetched once per session and shared by the
 * sidebar, dashboard and every dynamic page. Call `refresh()` after any
 * meta mutation so the whole shell stays in sync.
 */
const ObjectsContext = createContext({
    objects: [],
    loading: true,
    refresh: async () => {},
});

export function ObjectsProvider({ children }) {
    const [objects, setObjects] = useState([]);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await listMetaObjects();
            setObjects(Array.isArray(data) ? data : (data?.data ?? []));
        } catch (error) {
            console.error("Failed to load meta objects", { error });
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const value = useMemo(
        () => ({ objects, loading, refresh }),
        [objects, loading, refresh],
    );

    return (
        <ObjectsContext.Provider value={value}>
            {children}
        </ObjectsContext.Provider>
    );
}

export const useObjects = () => useContext(ObjectsContext);
